

interface HeroSectionProps {
  onScrollToSection: (sectionId: string) => void;
}

const HeroSection = ({ onScrollToSection }: HeroSectionProps) => {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(30, 58, 138, 0.8), rgba(30, 58, 138, 0.6)), url('https://public.readdy.ai/ai/img_res/614b5eb0bc17677d352d1d9912a4092b.jpg')`
      }}
    >
      <div className="container mx-auto px-4 py-20">
        <div className="max-w-4xl mx-auto text-center text-white">
          <div className="mb-8">
            <div className="flex items-center justify-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-orange-500 rounded-xl flex items-center justify-center">
                <span className="text-white font-bold text-xl">OA</span>
              </div>
              <span className="font-bold text-2xl" style={{ fontFamily: '"Pacifico", serif' }}>OCEANO AZUL Acadêmia Tributária BUSINESS</span>
            </div>
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            Imersão Online em
            <span className="text-orange-400 block">Buninss Tax: A única oportunidade real para o Brasil pelos próximos 100 anos.</span>
          </h1>
          
          <p className="text-xl md:text-2xl mb-8 text-blue-100 max-w-3xl mx-auto leading-relaxed">
            🎯 Um dia intensivo para advogados, bacharéis em direito, contadores, administradores e gestores públicos dominarem as oportunidades da Reforma Tributária
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <button
              onClick={() => onScrollToSection('inscricao')}
              className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap"
            >
              <i className="ri-user-add-line mr-2"></i>
              Inscreva-se Agora
            </button>
            <button
              onClick={() => onScrollToSection('programa')}
              className="border-2 border-white text-white hover:bg-white hover:text-blue-800 px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-file-list-3-line mr-2"></i>
              Ver Programa
            </button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
              <div className="w-8 h-8 bg-orange-500 rounded-lg flex items-center justify-center mx-auto mb-2">
                <i className="ri-calendar-line text-white"></i>
              </div>
              <p className="font-semibold">8 horas intensivas</p>
              <p className="text-sm text-blue-100">Conteúdo completo</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
              <div className="w-8 h-8 bg-orange-500 rounded-lg flex items-center justify-center mx-auto mb-2">
                <i className="ri-group-line text-white"></i>
              </div>
              <p className="font-semibold">Turma limitada</p>
              <p className="text-sm text-blue-100">Vargas limitadas</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
              <div className="w-8 h-8 bg-orange-500 rounded-lg flex items-center justify-center mx-auto mb-2">
                <i className="ri-award-line text-white"></i>
              </div>
              <p className="font-semibold">Certificado incluso</p>
              <p className="text-sm text-blue-100">Reconhecido no mercado</p>
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button
          onClick={() => onScrollToSection('target-audience')}
          className="text-white hover:text-orange-400 transition-colors"
        >
          <i className="ri-arrow-down-line text-2xl"></i>
        </button>
      </div>
    </section>
  );
};

export default HeroSection;


